import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const LifeInsuHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_LIFE_INSU_APP_BASE_URL });
export const LifeInsuHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: LifeInsuHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const LifeInsuHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: LifeInsuHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export default LifeInsuHttpConfig;
